'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import a$1 from "../defs/CaretLeft.js";
var i = Object.defineProperty, p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var a = (t, e, r) => e in t ? i(t, e, { enumerable: true, configurable: true, writable: true, value: r }) : t[e] = r, m = (t, e) => {
  for (var r in e || (e = {}))
    c.call(e, r) && a(t, r, e[r]);
  if (o)
    for (var r of o(e))
      n.call(e, r) && a(t, r, e[r]);
  return t;
}, f = (t, e) => p(t, s(e));
const I = forwardRef((t, e) => /* @__PURE__ */ a__default.createElement(b, f(m({ ref: e }, t), { weights: a$1 })));
I.displayName = "CaretLeft";
export {
  I as CaretLeft
};
